import { assetUrl } from '../config/asset-config';

(function () {
    'use strict';

    angular.module('thankview.video')
        .directive('tvVideoPlayer', ['$rootScope', '$timeout', 'ajax', 'vidJs', 'transition', '$window', '$document', 'logEventService', function ($rootScope, $timeout, ajax, vidJs, transition, $window, $document, logEventService) {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    var videoPlayerId = 'video-final-player';
                    var vidParams;
                    var timePos = [false, false, false];
                    var videoAnimating = false;
                    var endCardLength = 4;
                    var dontTrack = false;
                    var sansEnvelope = config.params && config.params.sans_envelope;
                    var card; var cardBack; var videoContainer; var
                        bkgdGradient;
                    var autoPlay = false;
                    var isPreview;
                    var isLanding;
                    let flipVideoOnEnd = true;
                    let videoElement;
                    let videoLoadRetries = 0;
                    let playedVideo = false;

                    scope.showUnmuteButton = false;

                    /**
                     * Applies CSS crop transform to the video player element.
                     * Reuses the same 4:3 crop algorithm from video-transform.js.
                     * @param {Object} cropData - { crop_id, width, height }
                     */
                    function applyCropTransform(cropData) {
                        var cropPercent = 1;
                        if (cropData.crop_id && cropData.width > cropData.height) {
                            cropPercent = ((cropData.width / cropData.height) / 1.333333).toFixed(6);
                        }
                        if (cropPercent > 1) {
                            videoElement.style.overflow = 'hidden';
                            var videoEl = videoElement.querySelector('video');
                            if (videoEl) {
                                videoEl.style.transform = 'scale(' + cropPercent + ')';
                            }
                            var poster = videoElement.querySelector('.vjs-poster');
                            if (poster) {
                                poster.style.backgroundSize = (cropPercent * 100) + '% ' + (cropPercent * 100) + '%';
                            }
                        }
                    }

                    /**
                     * Validate and sanitize a video URL before using it in an href.
                     * Allows only http/https absolute URLs and relative URLs.
                     *
                     * @param {string} rawUrl - The untrusted URL value.
                     * @param {string} baseUrl - Base URL to resolve relative URLs against.
                     * @returns {string|null} A safe URL string or null if invalid.
                     */
                    function getSafeVideoUrl(rawUrl, baseUrl) {
                        if (!rawUrl || typeof rawUrl !== 'string') {
                            return null;
                        }

                        try {
                            // If rawUrl is absolute, this will parse it; if relative, it will resolve against baseUrl.
                            var parsed = new URL(rawUrl, baseUrl);
                            var protocol = parsed.protocol.toLowerCase();

                            // Allow only http and https URLs.
                            if (protocol === 'http:' || protocol === 'https:') {
                                return parsed.href;
                            }

                            // Disallow all other protocols (e.g., javascript:, data:, etc.).
                            return null;
                        } catch (e) {
                            // If URL construction fails, treat as unsafe.
                            return null;
                        }
                    }

                    // open another video in the same player
                    scope.$on('switch-video', ($event, video) => {
                        const videoUrl = video.video_url;
                        videoElement = videoElement || $document[0].querySelector('#' + videoPlayerId);

                        vidParams = {
                            image: video.video_thumb,
                            skin: {
                                name: 'thankview',
                            },
                            muted: false,
                            autoplayCaptions: true,
                            captions: video.video_caption,
                        };

                        const existing = $document[0].querySelector('#video-js-player');
                        existing.remove();

                        vidJs.close('video-js-player');
                        vidJs.init('video-js-player', videoUrl, videoElement, vidParams);
                        vidJs.play();
                    });

                    // experimental playlist feature can broadcast to hide the unmute button
                    scope.$on('hide-mute', () => {
                        scope.showUnmuteButton = false;
                    });

                    scope.init = function () {
                        var muteButton = angular.element(element[0].querySelector('.tv-unmute-button'));
                        var muteText = angular.element(element[0].querySelector('.tv-unmute-text'));
                        var videoUrl = angular.element(element[0].querySelector('.video')).attr('data-video');
                        var captions = config.params ? config.params.video_caption : undefined;
                        const mediaQuery = $window.matchMedia('(prefers-reduced-motion: reduce)');

                        scope.videoId = element.attr('data-id');

                        // check if thankview shouldn't be tracked
                        var pathNames = $window.location.pathname.split('/');
                        isPreview = pathNames[2] && pathNames[2] === 'preview';
                        isLanding = pathNames[2] && pathNames[2] === 'landing';

                        dontTrack = !!(isLanding || isPreview || ($window.location.search && $window.location.search.indexOf('source=export') >= 0));

                        scope.replyUser = {
                            video_id: scope.videoId,
                            name: config.params ? config.params.reply_from_name : null,
                            email: config.params ? config.params.reply_from_email : null,
                        };

                        vidParams = {
                            image: config.params && config.params.video_thumb ? config.params.video_thumb : assetUrl('assets/img/white.jpg'),
                            skin: {
                                name: 'thankview',
                            },
                            muted: true,
                            autoplayCaptions: config.params ? config.params.autoplay_captions : true,
                            captions: captions,
                        };

                        // check for reduced motion preference
                        if (mediaQuery.matches) {
                            logEventService.addEvent('Autoplay Prevented by Reduced Motion Setting', 'Feature');
                            autoPlay = false;
                        } else {
                            autoPlay = true;
                        }

                        // get a reference to the video element
                        videoElement = $document[0].querySelector('#' + videoPlayerId);

                        // don't animate or load video when previewing
                        if (isLanding) {
                            autoPlay = false;
                            scope.dontAnimate = true;
                            // load the thumbnail to support non-envelope format previews
                            videoElement.parentElement.style.backgroundImage = `url(${vidParams.image})`;
                            videoElement.parentElement.style.height = '100%';
                            videoElement.parentElement.style.backgroundSize = 'cover';
                        } else {
                            if (config.params && config.params.project) {
                                flipVideoOnEnd = !config.params.project.no_end_card && config.params.project.outro_id;
                            }

                            vidJs.init('video-js-player', videoUrl, videoElement, vidParams);

                            // THANK-668: only crop the raw, un-baked recording.
                            // A baked video already has the crop applied server-side,
                            // so cropping again double-crops and zooms the intro.
                            if (config.params && config.params.crop_data
                                && config.params.crop_data.crop_id
                                && !config.params.crop_data.baked) {
                                vidJs.onReady(function () {
                                    applyCropTransform(config.params.crop_data);
                                });
                            }

                            vidJs.onError(() => {
                                const error = vidJs.getError();
                                // could not fetch media, let's retry after 1 second 3 times
                                if (error.code === 4 && videoLoadRetries < 3) {
                                    $timeout(() => {
                                        vidJs.load();
                                        videoLoadRetries += 1;

                                        if (playedVideo) {
                                            vidJs.play();
                                        }
                                    }, 1000);
                                }
                            });

                            vidJs.onFirstFrame(function () {
                                scope.showUnmuteButton = true;

                                muteButton.addClass('animate-unmute');
                                muteText.addClass('animate-unmute-text');

                                scope.watchedVideo('started_video');

                                if (cardBack) {
                                    cardBack.addClass('played');
                                }

                                // set focus for keyboard accessibility
                                $timeout(() => {
                                    muteButton[0].focus();
                                }, 100);
                            });

                            vidJs.onTime(function (time) {
                                // Commenting out for possible feature improvement in the future
                                // if (flipVideoOnEnd && time.position > time.duration - endCardLength + 1.5) {
                                //     scope.flipVideo();
                                //     scope.$apply();
                                // }

                                if (time.position > time.duration * 3 / 4 && !timePos[2]) {
                                    timePos[2] = true;
                                    scope.watchedVideo('video_pos_3');
                                } else if (time.position > time.duration / 2 && !timePos[1]) {
                                    timePos[1] = true;
                                    scope.watchedVideo('video_pos_2');
                                } else if (time.position > time.duration / 4 && !timePos[0]) {
                                    timePos[0] = true;
                                    scope.watchedVideo('video_pos_1');
                                }
                            });

                            vidJs.onComplete(function () {
                                scope.watchedVideo('finished_video');
                            });

                            vidJs.onVolumeChange(function () {
                                if (scope.showUnmuteButton && !scope.unmutedClicked) {
                                    scope.unmutedClicked = true;

                                    var duration = vidJs.getTime();
                                    if (duration < 10) {
                                        vidJs.seek(0);
                                    }

                                    $timeout(function () {
                                        scope.showUnmuteButton = false;
                                    }, 600);

                                    var params = {
                                        id: scope.videoId,
                                        status: 'user_unmuted',
                                    };

                                    if (scope.videoId && !dontTrack) {
                                        const url = $window.location.href;

                                        const apiRoute = scope.getApiRoute(url);

                                        const idString = scope.getIdString(url);
                                        if (idString) {
                                            params.id_string = idString;
                                        }

                                        ajax.get(apiRoute, params);
                                    }
                                }
                            });

                            vidJs.onPause(function () {
                                if (scope.showUnmuteButton && !scope.unmutedClicked) {
                                    scope.unmuteButton();
                                }
                            });
                        }

                        var downloadBut = $document[0].body.querySelector('.download-video');
                        if (downloadBut) {
                            var safeDownloadUrl = getSafeVideoUrl(videoUrl, $window.location.href);
                            if (safeDownloadUrl) {
                                downloadBut.href = safeDownloadUrl;
                            }
                        }

                        // allow parent frame to update thumbnail
                        $window.updateThumbnail = function (thumbnail) {
                            vidJs.close('video-js-player');
                            vidParams.image = thumbnail;
                            vidJs.init('video-js-player', videoUrl, videoElement, vidParams);
                        };

                        /**
                         * allow parent frame to update envelope text
                         * @param {*} envelopeTo - HTML markup for the text to display on an envelope
                         * @param {*} textColor - Hex code for the text color on the envelope
                         */
                        $window.updateEnvelopeTo = function (envelopeTo, textColor) {
                            var envelopeToEl = $document[0].getElementById('envelope-to-message');
                            if (envelopeToEl) {
                                envelopeToEl.innerHTML = envelopeTo;
                                envelopeToEl.style.color = textColor;
                            }
                            $rootScope.$broadcast('calculate-fit-text-size');
                        };

                        /**
                         * Function for replacing the envelope image in place
                         * @param {String} envImgUrl - url string to the image to use for the envelope
                         */
                        $window.updateEnvelopeImage = function (envImgUrl) {
                            const env = $document[0].getElementById('envelope-img');
                            if (env) {
                                env.src = envImgUrl;
                            }
                        };

                        // allow parent frame to update project description
                        $window.updateProjectDesc = function (projectDesc) {
                            var projectDescEl = $document[0].getElementById('cta-message-container');
                            if (projectDescEl) {
                                projectDescEl.innerHTML = projectDesc;
                                if (projectDesc !== '') {
                                    projectDescEl.classList.remove('none');
                                } else {
                                    projectDescEl.classList.add('none');
                                }
                            }
                            scope.projectDsc = projectDesc;
                        };

                        /**
                         * Function for inserting new CTA button markup to support the live preview
                         * @param {*} buttonMarkup - string of HTML representing the button
                         */
                        $window.updateCtaButton = function (buttonMarkup) {
                            var buttonContainer = $document[0].getElementById('cta-btn-container');
                            if (buttonContainer) {
                                buttonContainer.innerHTML = buttonMarkup;
                            }
                        };

                        /**
                         * Inject a new embed code for the live preview
                         * @param {*} embedCode - HTML string of the embed code
                         */
                        $window.updateEmbedCode = function (embedCode) {
                            ajax.post('/api/project/usableEmbedCode', { embed_code: embedCode }).then((data) => {
                                const embedContainer = $document[0].getElementById('embedded-content');
                                if (embedContainer) {
                                    embedContainer.innerHTML = data.embed_code || ''; // occasionally null, explicitly use empty string to avoid rendering 'null' in preview
                                }
                            });
                        };

                        /**
                         * Function to toggle hiding / showing the secondary action buttons.
                         * Must be provided a boolean for each individual button
                         * @param {Boolean} showReply - if reply button should be visible
                         * @param {Boolean} showDownload - if download button should be visible
                         * @param {Boolean} showShare - if share button should be visible
                         */
                        $window.updateSecondaryButtons = function (showReply, showDownload, showShare) {
                            // the logic here is a bit backwards and confusing given how we have to hide...
                            // the toggle function can be forced to only add or only remove the class
                            // in this case, we're removing the `none` class if a button should be shown
                            // so if a show param is true, we need to pass false to toggle() so it removes the none class
                            if ($document[0].getElementById('reply-button')) {
                                $document[0].getElementById('reply-button').classList.toggle('none', !showReply);
                            }
                            if ($document[0].getElementById('download-button')) {
                                $document[0].getElementById('download-button').classList.toggle('none', !showDownload);
                            }
                            if ($document[0].getElementById('s-button')) {
                                $document[0].getElementById('s-button').classList.toggle('none', !showShare);
                            }
                        };

                        angular.element($document[0].getElementById('cta-message-container')).on('click', function ($e) {
                            const target = $e.target;

                            if (target.nodeName === 'A' && target.href) {
                                $window.open(target.href, '_blank');
                                $e.preventDefault();
                            }
                        });

                        scope.checkLoaded();
                    };

                    scope.checkLoaded = function () {
                        if (!config.loaded) {
                            $timeout(function () {
                                scope.checkLoaded();
                            }, 100);
                            return;
                        }

                        card = angular.element(element[0].querySelector('.card'));
                        cardBack = angular.element(element[0].querySelector('.card-back'));
                        videoContainer = angular.element(element[0].querySelector('.video-final-container'));
                        bkgdGradient = angular.element($document[0].body.querySelector('.bkgd-gradient'));

                        // animate buttons after page is finished loading
                        var playerContainer = angular.element($document[0].body.querySelector('.player-container'));
                        var videoBelow = angular.element($document[0].body.querySelector('.video-below'));

                        if (!sansEnvelope) {
                            videoBelow.addClass('slide-fade');

                            $timeout(function () {
                                scope.animateCard();
                            }, 2000);
                        } else {
                            playerContainer.addClass('slide-fade');
                            videoBelow.addClass('slide-fade');

                            if (autoPlay) {
                                vidJs.play();
                                playedVideo = true;
                            }
                        }
                        // if this is a landing preview, we want to remove a loading indicator
                        if (isLanding) {
                            const path = 'https://' + $window.location.hostname;
                            $window.parent.postMessage('landing-loaded', path);
                        }
                    };

                    // set preview values based on url params
                    scope.setPreviewData = function () {
                        const queryParams = $window.location.search.split('?')[1];
                        if (queryParams) {
                            angular.forEach(queryParams.split('&'), function (param) {
                                const values = param.split('=');
                                if (values[0] === 'envelope_to') {
                                    $window.updateEnvelopeText(decodeURIComponent(values[1]));
                                } else if (values[0] === 'video_thumb') {
                                    $window.updateThumbnail(decodeURIComponent(values[1]));
                                }
                            });
                        }
                    };

                    scope.animateCard = function () {
                        // for previews to just show the front of the envelope
                        if (scope.dontAnimate) {
                            return;
                        }

                        var elapsedSinceStart = Date.now() - $window.tv_pageload_start;

                        var loading = angular.element(element[0].querySelector('.loading'));
                        var flapTopOutside = angular.element(element[0].querySelector('.flap-top-outside'));
                        var flapTopInside = angular.element(element[0].querySelector('.flap-top-inside'));
                        var flaps = angular.element(element[0].querySelector('.flaps'));

                        var params = {
                            id: scope.videoId,
                            status: 'envelope_start',
                            elapsed_since_start: elapsedSinceStart,
                        };

                        if (scope.videoId && !dontTrack) {
                            ajax.get('/api/watched', params);
                        }

                        loading.removeClass('flash-animation');

                        $timeout(function () {
                            card.addClass('flip');
                            transition.end(card, function () {
                                card.css('opacity', 0);

                                cardBack.addClass('flip');
                                transition.end(cardBack, function () {
                                    cardBack.addClass('flip-done');

                                    flapTopOutside.addClass('flip-up');
                                    transition.end(flapTopOutside, function () {
                                        flapTopOutside.css('opacity', 0);

                                        flapTopInside.addClass('flip-up');

                                        transition.end(flapTopInside, function () {
                                            if (!autoPlay) {
                                                videoContainer.css('display', 'block').css('opacity', 0);
                                            }

                                            $timeout(function () {
                                                params = {
                                                    id: scope.videoId,
                                                    status: 'envelope_end',
                                                };

                                                if (scope.videoId && !dontTrack) {
                                                    ajax.get('/api/watched', params);
                                                }

                                                element.addClass('grow');

                                                if (!autoPlay) {
                                                    videoContainer.css('opacity', 1);
                                                } else {
                                                    $timeout(function () {
                                                        videoContainer.css('display', 'block').css('opacity', 1);
                                                        vidJs.play();
                                                        playedVideo = true;
                                                    }, 200);
                                                }

                                                transition.end(flaps, function () {
                                                    element.addClass('watched');
                                                    card.removeClass('flip');
                                                    cardBack.addClass('playing');

                                                    // this fixes rendering the styles of this class
                                                    // in iOS. initially when the class is set, the
                                                    // box shadow is fully opaque, removing the class
                                                    // and adding back the class makes the box shadow
                                                    // render correctly
                                                    $timeout(function () {
                                                        cardBack.removeClass('playing');
                                                        $timeout(function () {
                                                            cardBack.addClass('playing');
                                                        });
                                                    });
                                                });
                                            }, 20);
                                        });
                                    });
                                });
                            });
                        }, 300);
                    };

                    scope.flipVideo = function () {
                        if (videoAnimating || scope.videoStopped) return false;

                        videoAnimating = true;
                        scope.hasFlipped = true;
                        scope.videoStopped = true;

                        cardBack.removeClass('reverse').addClass('flip-back');

                        transition.end(cardBack, function () {
                            cardBack.addClass('flip-back-message-visible');

                            $timeout(function () {
                                element.addClass('shrink');
                                cardBack.addClass('flip-back-message');

                                if (element.hasClass('has-desc')) bkgdGradient.addClass('shrink');
                            });

                            $timeout(function () {
                                videoAnimating = false;
                            }, 500);
                        });

                        return true;
                    };

                    scope.replayVideo = function ($event) {
                        if ($event) $event.preventDefault();

                        if (videoAnimating || !scope.videoStopped) {
                            return false;
                        }

                        videoAnimating = true;
                        scope.videoStopped = false;

                        cardBack.addClass('reverse').removeClass('flip-back-message');
                        element.removeClass('shrink');
                        bkgdGradient.removeClass('shrink');

                        transition.end(cardBack, function () {
                            cardBack.removeClass('flip-back-message-visible');

                            $timeout(function () {
                                cardBack.removeClass('flip-back');
                                vidJs.play();
                            });

                            $timeout(function () {
                                videoAnimating = false;
                            }, 500);
                        });

                        return true;
                    };

                    scope.watchedVideo = function (type) {
                        if (!scope.videoId || dontTrack) return;

                        var elapsedSinceStart = Date.now() - $window.tv_pageload_start;

                        var params = {
                            id: scope.videoId,
                            status: type,
                            elapsed_since_start: elapsedSinceStart,
                        };

                        const url = $window.location.href;

                        const apiRoute = scope.getApiRoute(url);

                        const idString = scope.getIdString(url);
                        if (idString) {
                            params.id_string = idString;
                        }

                        ajax.get(apiRoute, params);
                    };

                    scope.downloadVideo = function () {
                        if (!scope.videoId || dontTrack) {
                            return;
                        }

                        ajax.get('/api/watched/download', { id: scope.videoId });
                    };
                    scope.shareVideo = function ($event) {
                        $event.preventDefault();

                        if (dontTrack) {
                            $rootScope.$broadcast('open-message', 'This is how your recipient can share your ThankView.');
                            return;
                        }

                        // FB share popup window with custom size
                        var shareUrl = $window.location.href;
                        var appId = $window.config && $window.config.fbAppId ? $window.config.fbAppId : '';
                        var fbShareUrl = 'https://www.facebook.com/dialog/share?'
                            + 'app_id=' + encodeURIComponent(appId)
                            + '&display=popup'
                            + '&href=' + encodeURIComponent(shareUrl)
                            + '&redirect_uri=' + encodeURIComponent(shareUrl);

                        // Define popup dimensions
                        var width = 1024;
                        var height = 600;
                        var left = ($window.screen.width / 2) - (width / 2);
                        var top = ($window.screen.height / 2) - (height / 2);

                        // Open centered popup window
                        $window.open(
                            fbShareUrl,
                            'facebook-share-dialog',
                            'width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + ',toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes'
                        );

                        if (scope.videoId) ajax.get('/api/watched/share', { id: scope.videoId });
                    };

                    scope.openReply = function ($event) {
                        $event.preventDefault();

                        if (dontTrack) {
                            $rootScope.$broadcast('open-message', 'This is how your recipient can reply to your ThankView.');
                            return;
                        }

                        $rootScope.$broadcast('open-reply', scope.replyUser);
                    };

                    scope.cta_click = function () {
                        if (!scope.videoId || dontTrack) return;

                        var params = {
                            id: scope.videoId,
                            status: 'cta_clicked',
                        };

                        const url = $window.location.href;

                        const apiRoute = scope.getApiRoute(url);

                        const idString = scope.getIdString(url);
                        if (idString) {
                            params.id_string = idString;
                        }

                        ajax.get(apiRoute, params);
                    };

                    scope.stdSubmit = function () {
                        if (scope.loading || !scope.stdForm.$valid) return;

                        var params = {
                            reply: {
                                video_id: scope.videoId,
                                message: JSON.stringify(scope.std),
                            },
                        };

                        scope.loading = true;

                        ajax.post('/api/reply', params).then(function () {
                            $rootScope.$broadcast('open-message', 'Can\'t wait to see you!');

                            scope.std = {};

                            scope.stdForm.$setUntouched();
                            scope.stdForm.$setPristine();

                            scope.loading = false;
                        }).catch(function () {
                            scope.loading = false;
                        });
                    };

                    scope.getApiRoute = function (url) {
                        if (url.includes('/video/personal/')) {
                            return '/api/watched/personal';
                        }
                        if (url.includes('/video/signal/')) {
                            return '/api/watched/signal';
                        }
                        return '/api/watched';
                    };

                    scope.getIdString = function (url) {
                        if (url.includes('/video/personal/')) {
                            return url.split('/video/personal/')[1].split('?')[0];
                        }
                        if (url.includes('/video/signal/')) {
                            return url.split('/video/signal/')[1].split('?')[0];
                        }
                        return null;
                    };


                    scope.unmuteButton = function () {
                        vidJs.setAudio(true);
                    };

                    scope.init();
                },
            };
        }]);
}());
